export default "__VITE_ASSET__DJBTpDVc__"